import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TransportPlannerProfileEndpoint } from '../constants/transport-planner-profile-endpoint';
import { TransportPlannerProfileListStateModel } from './transport-planner-profile-list.state';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { PlannerProfileListSearchCriteria } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class TransportPlannerProfileListService {
  constructor(private http: WrapperHttpService) {}

  getTransportPlannerProfileList(
    searchCriteria: PlannerProfileListSearchCriteria,
  ): Observable<TransportPlannerProfileListStateModel> {
    const url =
      `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<TransportPlannerProfileListStateModel>(url);
  }
}
